import React, { Component } from 'react';
import { FieldGroup, FieldControl, FormBuilder, Validators } from 'react-reactive-form';
import { readableResponseMessage, scroller } from 'ux-helpers';
import PropTypes from 'proptypes';
import { Auth, API, Storage } from 'aws-amplify';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import ItineraryPreviewModal from './previewModals/ItineraryPreviewModal';
import Modal from 'react-modal';

export default class Itinerary extends Component {
  state = {
    itineraryDoc: this.props.itinerary ? this.props.itinerary : {},
    arrivalFlight:
      this.props.itinerary && this.props.itinerary.arrivalFlight
        ? this.props.itinerary.arrivalFlight.substring(
            0,
            this.props.itinerary.arrivalFlight.indexOf(',')
          )
        : '',
    departureFlight:
      this.props.itinerary && this.props.itinerary.departureFlight
        ? this.props.itinerary.departureFlight.substring(
            0,
            this.props.itinerary.departureFlight.indexOf(',')
          )
        : '',
    arrivalDateTime:
      this.props.itinerary && this.props.itinerary.arrivalDateTime
        ? moment(this.props.itinerary.arrivalDateTime)
        : moment(),
    departureDateTime:
      this.props.itinerary && this.props.itinerary.departureDateTime
        ? moment(this.props.itinerary.departureDateTime)
        : moment(),
  };

  componentDidMount() {
    const arrivalDateTimeInput = document.getElementById('arrivalDateTime');

    if (arrivalDateTimeInput !== null) {
      arrivalDateTimeInput.readOnly = true;
    }

    const departureDateTimeInput = document.getElementById('departureDateTime');

    if (departureDateTimeInput !== null) {
      departureDateTimeInput.readOnly = true;
    }

    let uploadField;

    if (document.getElementById('initial-itinerary-upload-field') !== null) {
      uploadField = document.getElementById('initial-itinerary-upload-field');
    } else {
      uploadField = document.getElementById('update-itinerary-upload-field');
    }

    uploadField.onchange = () => {
      if (uploadField.files[0].size > 2000000) {
        this.setState({
          successOrErrorMessage: false,
          message: 'File size exceeds 2mb. Please choose a smaller file.',
        });
        uploadField.value = '';
      } else {
        this.setState({
          message: '',
        });
      }
    };
  }

  createArrivalFlightExample = () => {
    var airportCode = '';
    if (this.props.destination === 'Nicaragua') {
      airportCode = 'ATL/MGO';
    } else if (this.props.destination === 'Tanzania') {
      airportCode = 'AMS/DAR';
    } else if (this.props.destination === 'Thailand') {
      airportCode = 'HKG/CNX';
    } else if (this.props.destination === 'Laos') {
      airportCode = 'BKK/LPQ';
    } else if (this.props.destination === 'Nepal') {
      airportCode = 'DOH/KTM';
    } else if (this.props.destination === 'Southeast Asia: Thailand & Laos') {
      airportCode = 'HKG/CNX';
    }
    var formattedFlightExample = airportCode + ' DL9349';
    return formattedFlightExample;
  };

  createDepartureFlightExample = () => {
    var airportCode = '';
    if (this.props.destination === 'Nicaragua') {
      airportCode = 'MGO/ATL';
    } else if (this.props.destination === 'Tanzania') {
      airportCode = 'JRO/DOH';
    } else if (this.props.destination === 'Thailand') {
      airportCode = 'CNX/HKG';
    } else if (this.props.destination === 'Laos') {
      airportCode = 'LPQ/BKK';
    } else if (this.props.destination === 'Nepal') {
      airportCode = 'KTM/DOH';
    } else if (this.props.destination === 'Southeast Asia: Thailand & Laos') {
      airportCode = 'LPQ/BKK';
    }
    var formattedFlightExample = airportCode + ' CA5232';
    return formattedFlightExample;
  };

  onImageSelect = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        () =>
          this.setState({
            travelDocument: reader.result,
          }),
        false
      );
      reader.readAsDataURL(e.target.files[0]);
      this.itineraryForm.controls.travelDocument.setValue(e.target.files[0]);
      this.setState({
        travelDocumentFileName: e.target.files[0].name,
      });
    }
  };

  uploadDocument = document => {
    const fileName = document.name;
    const fileType = document.type;
    Storage.put(fileName, document, {
      level: 'protected',
      contentType: fileType,
    }).catch(error => {
      this.setState({
        message: 'Whoops! Looks like we had a problem uploading your file.',
      });
    });
  };

  returnFileNameAndType = () => {
    const url = this.state.itineraryDoc.travelDocumentURL;
    const fileName = url.substring(url.lastIndexOf('/') + 1);
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    return {
      key: url,
      type: extension,
    };
  };

  openModal = modalName => {
    let fileAttributes = this.returnFileNameAndType();
    Storage.get(fileAttributes.key, { level: 'protected' })
      .then(result => {
        if (
          fileAttributes.type === 'pdf' ||
          fileAttributes.type === 'doc' ||
          fileAttributes.type === 'docx'
        ) {
          window.open(result);
        } else {
          this.setState({
            previewUrl: result,
            activeModal: modalName,
          });
        }
      })
      .catch(() => {});
  };

  closeModal = () => {
    this.setState({
      activeModal: null,
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    if (this.itineraryForm.status === 'VALID') {
      this.setState({ loadingBtn: true });
      this.itineraryForm.handleSubmit();
      Auth.currentSession().then(user => {
        const options = {
          headers: {
            Authorization: user.idToken.jwtToken,
            Token: user.accessToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: this.itineraryForm.value,
        };
        options.body.userId = this.props.userId;
        options.body.userName = user.idToken.payload.nickname;
        options.body.travelDocument = this.state.travelDocument;
        options.body.fileName = this.state.travelDocumentFileName;

        // 14 Jul 21 AMS/DAR DL9349 @ 3:00pm
        const arrivalDateFormat = moment(this.itineraryForm.controls.arrivalDateTime.value).format(
          'DD MMM YY @ h:mma'
        );
        const departureDateFormat = moment(
          this.itineraryForm.controls.departureDateTime.value
        ).format('DD MMM YY @ h:mma');
        options.body.arrivalFlight =
          this.itineraryForm.controls.arrivalFlight.value + ', ' + arrivalDateFormat;
        options.body.departureFlight =
          this.itineraryForm.controls.departureFlight.value + ', ' + departureDateFormat;

        this.uploadDocument(this.itineraryForm.controls.travelDocument.value);
        API.post('give-api', `/documents/${this.props.tripId}/itinerary`, options)
          .then(response => {
            this.setState({
              successOrErrorMessage: true,
              loadingBtn: false,
              message: response.Message,
              itineraryDoc: {
                arrivalFlight: response.Data.Arrival_Flight__c,
                arrivalDateTime: response.Data.Arrival_Date_Time__c,
                departureFlight: response.Data.Departure_Flight__c,
                departureDateTime: response.Data.Departure_Date_Time__c,
                travelDocumentURL: response.Data.travelDocumentUrl
                  ? response.Data.travelDocumentUrl
                  : this.state.itineraryDoc.travelDocumentURL,
              },
            });
            this.props.setDocumentsAccordionState('itinerary');
            this.itineraryForm.handleSubmit();
            this.setState({ travelDocument: '' });
            this.props.deactiveActiveAccordion('itinerary-widget');
            scroller('arrivalFlight');
            setTimeout(() => {
              this.setState({ message: '' });
            }, 3000);
          })
          .catch(error => {
            this.setState({
              successOrErrorMessage: false,
              loadingBtn: false,
              message: readableResponseMessage(error),
            });
            this.itineraryForm.handleSubmit();
            scroller('arrivalFlight');
          });
      });
    } else {
      this.itineraryForm.handleSubmit();
    }
  };

  itineraryForm = FormBuilder.group({
    arrivalFlight: [
      this.state.arrivalFlight ? this.state.arrivalFlight : '',
      [Validators.required, Validators.maxLength(50)],
    ],
    arrivalDateTime: [
      this.state.arrivalDateTime ? this.state.arrivalDateTime : '',
      Validators.required,
    ],
    departureFlight: [
      this.state.departureFlight ? this.state.departureFlight : '',
      [Validators.required, Validators.maxLength(50)],
    ],
    departureDateTime: [
      this.state.departureDateTime ? this.state.departureDateTime : '',
      Validators.required,
    ],
    travelDocument: [
      this.state.itineraryDoc && this.state.itineraryDoc.travelDocumentURL
        ? this.state.itineraryDoc.travelDocumentURL
        : '',
      Validators.required,
    ],
  });

  handleArrivalDateChange = date => {
    const formattedDate = moment(date).format();
    this.itineraryForm.controls.arrivalDateTime.setValue(formattedDate);
    this.setState({
      arrivalDateTime: date,
    });
  };

  handleDepartureDateChange = date => {
    const formattedDate = moment(date).format();
    this.itineraryForm.controls.departureDateTime.setValue(formattedDate);
    this.setState({
      departureDateTime: date,
    });
  };

  render() {
    return (
      <div>
        {this.state.itineraryDoc.reasonDeclined ? (
          <div className="col-md-12 warning-text-container">
            <p className="warning-color">{this.state.itineraryDoc.reasonDeclined}</p>
          </div>
        ) : (
          ''
        )}
        <p>
          GIVE has preferred itineraries and partners with dedicated flight agents so you can book
          with confidence. Book simply and stress-free with personalized quotes, access to
          discounts, trusted routing, end-to-end guidance, 24/7 support while you travel and, when
          possible, fly with other GIVE travelers.
          <br />
          <br />
          We'll email you when flights are released (or check your trip flight status on the left
          under "Important Info"). Once flights are released, submit our flight booking form below
          to receive a quote from our dedicated agents and book your round-trip flights from your
          home city to your host location. It's important to book flights ASAP once they're released
          for your trip to secure the lowest airfare!
          <br />
          <br />
          <b>Important:</b> Quoted airfare is valid for a limited time, and prices can change daily
          based on availability. To get the lowest fares, book as soon as flights are released for
          your trip.
          <br />
          <br />
          Let's make it seamless. For more information{' '}
          <button className="btn-plain-text" onClick={this.props.openModal}>
            click here!
          </button>
        </p>
        <br />
        <span className="round-icon small">1</span>
        <span>
          {' '}
          Submit a{' '}
          <a
            href="https://go.givevolunteers.org/bookflights"
            target="_blank"
            rel="noopener noreferrer"
          >
            booking request form
          </a>{' '}
          and work with our agents to purchase your flights.
        </span>
        <p>
          <span className="round-icon small">2</span> Enter your arrival and departure flight
          numbers and dates in the fields below.
        </p>
        {this.state.message ? (
          <p
            id="error"
            className={`center ${this.state.successOrErrorMessage === true ? 'success' : 'error'}`}
          >
            {this.state.message}
          </p>
        ) : (
          ''
        )}
        <FieldGroup
          control={this.itineraryForm}
          render={({ value, submitted }) => (
            <form
              name="Itinerary"
              id="itinerary-form"
              onSubmit={e => this.handleSubmit(e, value)}
              autoComplete="off"
            >
              <FieldControl
                name="arrivalDateTime"
                render={({ touched, hasError, pristine }) => (
                  <div className="inputContainer datepicker">
                    <DatePicker
                      id="arrivalDateTime"
                      className="form-control"
                      selected={this.state.arrivalDateTime}
                      onChange={this.handleArrivalDateChange}
                      showTimeSelect
                      timeFormat="h:mm A"
                      timeIntervals={1}
                      dateFormat="LLL"
                      timeCaption="time"
                      minDate={moment()}
                      popperModifiers={{
                        flip: {
                          enabled: false,
                        },
                        preventOverflow: {
                          enabled: true,
                          escapeWithReference: false,
                        },
                      }}
                    />
                    <label
                      htmlFor="arrivalDateTime"
                      className={`label ${
                        pristine && !this.itineraryForm.controls.arrivalDateTime.value
                          ? ''
                          : 'notEmpty'
                      }`}
                    >
                      Arrival Date and Time
                      <span className="error">
                        {(touched || submitted) && hasError('required') && ' - Required'}
                      </span>
                    </label>
                  </div>
                )}
              />
              <FieldControl
                name="arrivalFlight"
                render={({ handler, touched, hasError, pristine }) => (
                  <div className="inputContainer">
                    <input id="arrivalFlight" className="form-control" type="text" {...handler()} />
                    <label
                      htmlFor="arrivalFlight"
                      className={`label ${
                        pristine && !this.itineraryForm.controls.arrivalFlight.value
                          ? ''
                          : 'notEmpty'
                      }`}
                    >
                      Arrival Flight, Example: {this.createArrivalFlightExample()}
                      <span className="error">
                        {(touched || submitted) && hasError('required') && ' - Required'}
                        {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                      </span>
                    </label>
                  </div>
                )}
              />
              <FieldControl
                name="departureDateTime"
                render={({ touched, hasError, pristine }) => (
                  <div className="inputContainer datepicker">
                    <DatePicker
                      id="departureDateTime"
                      className="form-control"
                      selected={this.state.departureDateTime}
                      onChange={this.handleDepartureDateChange}
                      showTimeSelect
                      timeFormat="h:mm A"
                      timeIntervals={1}
                      dateFormat="LLL"
                      timeCaption="time"
                      minDate={moment()}
                      popperModifiers={{
                        flip: {
                          enabled: false,
                        },
                        preventOverflow: {
                          enabled: true,
                          escapeWithReference: false,
                        },
                      }}
                    />
                    <label
                      htmlFor="departureDateTime"
                      className={`label ${
                        pristine && !this.itineraryForm.controls.departureDateTime.value
                          ? ''
                          : 'notEmpty'
                      }`}
                    >
                      Departure Date and Time
                      <span className="error">
                        {(touched || submitted) && hasError('required') && ' - Required'}
                      </span>
                    </label>
                  </div>
                )}
              />
              <FieldControl
                name="departureFlight"
                render={({ handler, touched, hasError, pristine }) => (
                  <div className="inputContainer">
                    <input
                      id="departureFlight"
                      className="form-control"
                      type="text"
                      {...handler()}
                    />
                    <label
                      htmlFor="departureFlight"
                      className={`label ${
                        pristine && !this.itineraryForm.controls.departureFlight.value
                          ? ''
                          : 'notEmpty'
                      }`}
                    >
                      Departure Flight, Example: {this.createDepartureFlightExample()}
                      <span className="error">
                        {(touched || submitted) && hasError('required') && ' - Required'}
                        {hasError('maxLength') && ' - Exceeds Maximum Number of Characters'}
                      </span>
                    </label>
                  </div>
                )}
              />
              <p>
                <span className="round-icon small">3</span> Take a screenshot of your itinerary or
                download the PDF with your entire flight itinerary (both arrival and departure) and
                upload!
              </p>

              <br />
              {this.state.itineraryDoc && !this.state.itineraryDoc.travelDocumentURL ? (
                <FieldControl
                  name="travelDocument"
                  render={({ touched, hasError }) => (
                    <div className="inputContainer">
                      <input
                        className="form-control"
                        type="file"
                        id="initial-itinerary-upload-field"
                        onChange={this.onImageSelect}
                      />
                      <label htmlFor="travelDocument" className="label notEmpty">
                        Flight Itinerary Photo
                        <span className="error">
                          {(touched || submitted) && hasError('required') && ' - Required'}
                        </span>
                      </label>
                    </div>
                  )}
                />
              ) : null}
            </form>
          )}
        />
        {this.state.itineraryDoc && this.state.itineraryDoc.travelDocumentURL ? (
          <div>
            <p>
              Itinerary Photo Uploaded!{' '}
              <button
                className="inline btn-plain-text"
                onClick={() => this.openModal('itineraryPreviewModal')}
              >
                &#8226; Preview
              </button>
              <span className="upload-btn-wrapper">
                &#8226; {!this.state.travelDocument ? 'Update/Add' : 'Update'}
                <input
                  id="update-itinerary-upload-field"
                  type="file"
                  onChange={this.onImageSelect}
                />
              </span>
              <br />
            </p>
          </div>
        ) : null}
        <button
          onClick={e => this.handleSubmit(e)}
          className={`${this.state.loadingBtn ? 'btn-text-hide' : ''}`}
          type="submit"
          disabled={this.state.loadingBtn}
        >
          Submit
          <span className={`${this.state.loadingBtn ? 'loader' : ''}`} />
        </button>
        <Modal
          isOpen={this.state.activeModal === 'itineraryPreviewModal'}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <ItineraryPreviewModal previewUrl={this.state.previewUrl} closeModal={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

Itinerary.propTypes = {
  userId: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired,
  setDocumentsAccordionState: PropTypes.func.isRequired,
  itinerary: PropTypes.shape({
    arrivalFlight: PropTypes.string,
    arrivalDateTime: PropTypes.string,
    departureFlight: PropTypes.string,
    departureDateTime: PropTypes.string,
    travelDocumentURL: PropTypes.string,
  }).isRequired,
};
